<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "Booking Update",
      items: [
        {
          text: "Booking list",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
        bookingId:"",
        is_ticket:false,
        booking_statuses:[],
      form: {
        booking_status: "",
        airline_pnr: "",
          api_pnr:"",
          base_fare:"",
          gross_fare:"",
          total_tax:"",
          invoice_fare:"",
          airline:"",
          trip_type:"",
          ait:"",
          currency:"",
          markup:"",
          commission:"",
          payment_status:"",
          flight_segments:[],
          passenger_info:[],
          tickets:[]
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        booking_status: {
        required,
      },
        airline_pnr: {
        required,
      },
        api_pnr: {
            required,
        },
        base_fare: {
            required,
        },
        gross_fare: {
            required,
        },
        total_tax: {
            required,
        },
        invoice_fare: {
            required,
        },
        ait: {
            required,
        },
        currency: {
            required,
        },
        airline: {
            required,
        },
        trip_type: {
            required,
        },
        markup: {
            required,
        },
        commission: {
            required,
        },
        payment_status: {
            required,
        },
        flight_segments: {
            required,
            $each:true
        },
        passenger_info: {
            required,
            $each: true
        }
    },
  },
  created() {
    this.bookingId = this.$route.params.id;
      if(this.$route.params.is_ticketing!=undefined){
          this.is_ticket = this.$route.params.is_ticketing;
      }

  },
  mounted() {
    this.getBookingDetail();
    this.getBookingStatuses();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getBookingDetail() {
          try {
              axios
                  .post("/api/flight-booking/details/" + this.bookingId, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          // let passInfo=response.data.data.flight_passengers;
                          // let tick=response.data.data.tickets;
                          // let j;
                          // let assign=new Array();
                          // if(tick.length==0){
                          //     for(j=0;j<passInfo.length;j++){
                          //         assign[j]={ticket_no:''};
                          //     }
                          //     this.form.tickets=assign;
                          // }else{
                          //     this.form.tickets=tick;
                          // }
                          this.form.passenger_info=response.data.data.flight_passengers;
                          this.booking=response.data.data;
                          let segments=response.data.data.flight_segments;
                          let i;
                          for (i=0;i<segments.length;i++){
                             let arrival=segments[i].arrival_date.split(' ').join('T');
                              let departure=segments[i].destination_date.split(' ').join('T');
                              segments[i].arrival_date=arrival;
                              segments[i].destination_date=departure;
                          }
                          this.form.flight_segments=segments;
                          // this.status=response.data.data.status;
                          let book=response.data.data;
                          this.form.booking_status=response.data.data.booking_status.status_tag;
                          this.form.airline_pnr=book.airline_pnr;
                          this.form.api_pnr=book.api_pnr;
                          this.form.base_fare=book.base_fare;
                          this.form.gross_fare=book.gross_fare;
                          this.form.total_tax=book.total_tax;
                          this.form.invoice_fare=book.invoice_fare;
                          this.form.ait=book.ait;
                          this.form.currency=book.currency;
                          this.form.airline=book.airline;
                          this.form.trip_type=book.trip_type;
                          this.form.commission=book.commission;
                          this.form.markup=book.markup;
                          this.form.payment_status=book.payment_status;

                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getBookingStatuses() {
          try {
              axios
                  .get("/api/flight-booking/statuses", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.booking_statuses = response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/flight-booking/update", {
          id: this.bookingId,
            booking_status: this.form.booking_status,
            airline_pnr: this.form.airline_pnr,
            api_pnr: this.form.api_pnr,
            base_fare: this.form.base_fare,
            gross_fare: this.form.gross_fare,
            total_tax: this.form.total_tax,
            invoice_fare: this.form.invoice_fare,
            ait: this.form.ait,
            currency: this.form.currency,
            airline: this.form.airline,
            trip_type: this.form.trip_type,
            markup:this.form.markup,
            is_ticket:this.is_ticket,
            commission: this.form.commission,
            payment_status: this.form.payment_status,
            flight_segments: this.form.flight_segments,
            passenger_info: this.form.passenger_info,
            tickets:this.form.tickets,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.bookingUpdateForm.reset();
            this.$swal("Good job!", "Booking Updated", "success");
            if(!this.is_ticket){
                this.$router.push({ name: "flight_booking_list" });
            }else{
                this.$router.push({ name: "flight_ticket_list" });
            }
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="bookingUpdateForm" @submit.prevent="formSubmit">
                <h4>Booking Information</h4>
              <div class="row">
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Select Booking Status</label>
                          <select
                              id="booking_status"
                              name="booking_status"
                              v-model="form.booking_status"
                              class="form-control"
                              placeholder="Type Status">
                              <option v-for="(status, index) in booking_statuses" :value="status.status_tag"
                                      v-bind:key="index">{{ status.status_name }}
                              </option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label> Select Payment Status</label>
                          <select
                              id="payment_status"
                              v-model="form.payment_status"
                              name="payment_status"
                              type="text"
                              class="form-control"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.trip_type.$error }">
                              <option value="" disabled style="display:none" selected>Select Role Type</option>
                              <option value="unpaid">Unpaid</option>
                              <option value="partially-paid">Partially Paid</option>
                              <option value="full-paid">Full Paid</option>
                              <option value="refunded">Refunded</option>
                          </select>
                          <div
                              v-if="submitted && $v.form.payment_status.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.payment_status.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Airline</label>
                          <input
                              id="airline"
                              v-model="form.airline"
                              name="airline"
                              type="text"
                              class="form-control"
                              placeholder="base fare"
                              :class="{ 'is-invalid': submitted && $v.form.airline.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.airline.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airline.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label >Trip Type</label>
                          <select
                              id="trip_type"
                              v-model="form.trip_type"
                              name="trip_type"
                              type="text"
                              class="form-control"
                              placeholder="Type Trip Type"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.trip_type.$error }">
                              <option value="" disabled style="display:none" selected>Select Role Type</option>
                              <option value="One Way">One Way</option>
                              <option value="Return">Return</option>
                              <option value="Round Trip">Round Trip</option>
                              <option value="Multi City">Multi City</option>
                          </select>
                          <div
                              v-if="submitted && $v.form.trip_type.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.trip_type.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Airline Pnr</label>
                          <input
                              id="airline_pnr"
                              v-model="form.airline_pnr"
                              name="airline_pnr"
                              type="text"
                              class="form-control"
                              placeholder="airline pnr"
                              :class="{ 'is-invalid': submitted && $v.form.airline_pnr.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.airline_pnr.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airline_pnr.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Api Pnr</label>
                          <input
                              id="api_pnr"
                              v-model="form.api_pnr"
                              name="api_pnr"
                              type="text"
                              class="form-control"
                              placeholder="api pnr"
                              :class="{ 'is-invalid': submitted && $v.form.api_pnr.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.api_pnr.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.api_pnr.required">This value is required.</span>
                          </div>
                      </div>
                  </div>

              </div>
                <h4>Fare Information</h4>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Gross Fare</label>
                            <input
                                id="gross_fare"
                                v-model="form.gross_fare"
                                name="gross_fare"
                                type="text"
                                class="form-control"
                                placeholder="gross fare"
                                :class="{ 'is-invalid': submitted && $v.form.gross_fare.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.gross_fare.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.gross_fare.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Total Tax</label>
                            <input
                                id="total_tax"
                                v-model="form.total_tax"
                                name="total_tax"
                                type="text"
                                class="form-control"
                                placeholder="total tax"
                                :class="{ 'is-invalid': submitted && $v.form.total_tax.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.total_tax.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.total_tax.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Base Fare</label>
                            <input
                                id="base_fare"
                                v-model="form.base_fare"
                                name="base_fare"
                                type="text"
                                class="form-control"
                                placeholder="base fare"
                                :class="{ 'is-invalid': submitted && $v.form.base_fare.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.base_fare.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.base_fare.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Invoice Fare</label>
                            <input
                                id="invoice_fare"
                                v-model="form.invoice_fare"
                                name="invoice_fare"
                                type="text"
                                class="form-control"
                                placeholder="base fare"
                                :class="{ 'is-invalid': submitted && $v.form.invoice_fare.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.invoice_fare.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.invoice_fare.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Ait</label>
                            <input
                                id="ait"
                                v-model="form.ait"
                                name="ait"
                                type="text"
                                class="form-control"
                                placeholder="ait"
                                :class="{ 'is-invalid': submitted && $v.form.ait.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.ait.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.ait.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Currency</label>
                            <input
                                id="currency"
                                v-model="form.currency"
                                name="currency"
                                type="text"
                                class="form-control"
                                placeholder="ait"
                                :class="{ 'is-invalid': submitted && $v.form.currency.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.currency.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.currency.required">This value is required.</span>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Commission</label>
                            <input
                                id="commission"
                                v-model="form.commission"
                                name="commission"
                                type="text"
                                class="form-control"
                                placeholder="commission"
                                :class="{ 'is-invalid': submitted && $v.form.commission.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.commission.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.commission.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Markup</label>
                            <input
                                id="markup"
                                v-model="form.markup"
                                name="markup"
                                type="text"
                                class="form-control"
                                placeholder="markup"
                                :class="{ 'is-invalid': submitted && $v.form.markup.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.markup.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.markup.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <h4>Flight Information</h4>
                <div class="row">
                    <div class="col-md-3" v-for="(flight,index) in form.flight_segments"  v-bind:key="index">
                        <div class="col-md-12">
                            <div class="form-group">
                                <h5>Flight {{ index+1}}</h5>
                                <input
                                    id="operating_flight_number+'index'"
                                    v-model="form.flight_segments[index].operating_flight_number"
                                    name="operating_flight_number+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="flight number"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.flight_segments[index].operating_flight_number.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.flight_segments[index].operating_flight_number.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Origin</label>
                                <input
                                    id="origin_code+'index'"
                                    v-model="form.flight_segments[index].origin_code"
                                    name="origin_code+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="flight number"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.flight_segments[index].origin_code.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.flight_segments[index].origin_code.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Destination</label>
                                <input
                                    id="destination_code+'index'"
                                    v-model="form.flight_segments[index].destination_code"
                                    name="destination_code+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="destination code"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.flight_segments[index].destination_code.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.flight_segments[index].destination_code.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-form-group
                                id="destination_date+'index'"
                                label-cols-sm="12"
                                label-cols-lg="12"
                                label="Departure Date Time"
                                label-for="Departure Date Time"
                            >
                                <!--                                <b-form-datepicker id="destination_date+'index'" v-model="form.flight_segments[index].destination_date" value="form.passenger_info[index].arrival_date"  class="mb-2"></b-form-datepicker>-->
                                <b-form-input id="destination_date+'index'" v-model="form.flight_segments[index].destination_date" :value="form.flight_segments[index].destination_date"  type="datetime-local"></b-form-input>

                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.flight_segments[index].destination_date.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.flight_segments[index].destination_date.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <b-form-group
                                id="arrival_date+'index'"
                                label-cols-sm="12"
                                label-cols-lg="12"
                                label="Arrival Date Time"
                                label-for="Arrival Date Time"
                            >
                                <b-form-input id="arrival_date+'index'" v-model="form.flight_segments[index].arrival_date" :value="form.flight_segments[index].arrival_date"  type="datetime-local"></b-form-input>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.flight_segments[index].arrival_date.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.flight_segments[index].arrival_date.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Travel Duration</label>
                                <input
                                    id="travel_duration+'index'"
                                    v-model="form.flight_segments[index].travel_duration"
                                    name="travel_duration+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="travel duration"
                                />
<!--                                                                <div-->
<!--                                                                    v-if="submitted && $v.form.form.flight_segments[index].travel_duration.$error"-->
<!--                                                                    class="invalid-feedback"-->
<!--                                                                >-->
<!--                                                                    <span v-if="!$v.form.form.flight_segments[index].travel_duration.required">This value is required.</span>-->
<!--                                                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Booking Class</label>
                                <input
                                    id="booking_class+'index'"
                                    v-model="form.flight_segments[index].booking_class"
                                    name="booking_class+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="booking class"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.flight_segments[index].booking_class.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.flight_segments[index].booking_class.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Baggage Info</label>
                                <input
                                    id="baggage_information+'index'"
                                    v-model="form.flight_segments[index].baggage_information"
                                    name="baggage_information+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="baggage info"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.flight_segments[index].booking_class.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.flight_segments[index].booking_class.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <h4>Passenger Information</h4>
                <div class="row">
                    <div class="col-md-3" v-for="(passenger,index) in form.passenger_info" v-bind:key="index">
                        <h5>Passenger {{index+1}}</h5>
<!--                        <div class="col-md-12">-->
<!--                            <div class="form-group">-->
<!--                                <label>Prefix</label>-->
<!--                                <input-->
<!--                                    id="prefix+'index'"-->
<!--                                    v-model="form.passenger_info[index].prefix"-->
<!--                                    name="prefix+'index'"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="passenger prefix"-->
<!--                                />-->
<!--&lt;!&ndash;                                <div&ndash;&gt;-->
<!--&lt;!&ndash;                                    v-if="submitted && $v.form.form.passenger_info[index].prefix.$error"&ndash;&gt;-->
<!--&lt;!&ndash;                                    class="invalid-feedback"&ndash;&gt;-->
<!--&lt;!&ndash;                                >&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span v-if="!$v.form.form.passenger_info[index].prefix.required">This value is required.</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Prefix</label>
                                <select
                                    id="prefix+'index'"
                                    v-model="form.passenger_info[index].prefix"
                                    name="prefix+'index'"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    placeholder="prefix"
                                >
                                    <option value="" disabled style="display:none" selected>Prefix</option>
                                    <option value="Miss">Miss</option>
                                    <option value="Mr">Mr</option>
                                    <option value="Mrs">Mrs</option>
                                    <option value="Mstr">Mstr</option>
                                    <option value="Ms">Ms</option>
                                </select>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].is_lead_pax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].is_lead_pax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>First Name</label>
                                <input
                                    id="passenger_info+'index'"
                                    v-model="form.passenger_info[index].first_name"
                                    name="passenger_info+'index'"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    placeholder="passenger first name"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].first_name.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].first_name.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Last Name</label>
                                <input
                                    id="last_name+'index'"
                                    v-model="form.passenger_info[index].last_name"
                                    name="last_name+'index'"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    placeholder="passenger last name"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].last_name.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].last_name.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-form-group
                                id="birth_date+'index'"
                                label-cols-sm="12"
                                label-cols-lg="12"
                                label="Birth Date"
                                label-for="end_dateTime"
                            >
<!--                                <b-form-datepicker id="birth_date+'index'" v-model="form.passenger_info[index].date_of_birth" value="form.passenger_info[index].date_of_birth"  class="mb-2"></b-form-datepicker>-->
                                <b-form-input id="birth_date+'index'" v-model="form.passenger_info[index].date_of_birth" :value="form.passenger_info[index].date_of_birth" type="date"></b-form-input>
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.passenger_info[index].date_of_birth.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.passenger_info[index].date_of_birth.required">This value is required.</span>-->
<!--                                </div>-->
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passenger Type</label>
                                <input
                                    id="passenger_type+'index'"
                                    v-model="form.passenger_info[index].passenger_type"
                                    name="last_name+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger type"

                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].passenger_type.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].passenger_type.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Is Lead Passenger</label>
                                <select
                                    id="is_lead_pax+'index'"
                                    v-model="form.passenger_info[index].is_lead_pax"
                                    name="trip_type"
                                    type="text"
                                    class="form-control"
                                    placeholder="is lead passenger"
                                   >
                                    <option value="" disabled style="display:none" selected>Is lead pax</option>
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.passenger_info[index].is_lead_pax.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.passenger_info[index].is_lead_pax.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Gender</label>
                                <select
                                    id="gender+'index'"
                                    v-model="form.passenger_info[index].gender"
                                    name="gender+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type gender"
                                    value
                                   >
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.passenger_info[index].gender.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.passenger_info[index].gender.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Nationality</label>
                                <input
                                    id="nationality+'index'"
                                    v-model="form.passenger_info[index].nationality"
                                    name="nationality+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger type"

                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].nationality.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].nationality.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Base Fare</label>
                                <input
                                    id="base_fare+'index'"
                                    v-model="form.passenger_info[index].base_fare"
                                    name="base_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="base fare"
                                />

                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Gross Fare</label>
                                <input
                                    id="gross_fare+'index'"
                                    v-model="form.passenger_info[index].gross_fare"
                                    name="gross_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="gross fare"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].gross_fare.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].gross_fare.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Total Tax</label>
                                <input
                                    id="total_tax+'index'"
                                    v-model="form.passenger_info[index].total_tax"
                                    name="total_tax+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="total tax"

                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Ait</label>
                                <input
                                    id="ait+'index'"
                                    v-model="form.passenger_info[index].ait"
                                    name="ait+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="ait"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Markup</label>
                                <input
                                    id="passenger_markup+'index'"
                                    v-model="form.passenger_info[index].markup"
                                    name="passenger_markup+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="markup"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Commission</label>
                                <input
                                    id="commission+'index'"
                                    v-model="form.passenger_info[index].commission"
                                    name="total_tax+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="commission"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Currency</label>
                                <input
                                    id="currency+'index'"
                                    v-model="form.passenger_info[index].currency"
                                    name="currency+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="currency"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Invoice Fare</label>
                                <input
                                    id="invoice_fare+'index'"
                                    v-model="form.passenger_info[index].invoice_fare"
                                    name="invoice_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="invoice fare"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].invoice_fare.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].invoice_fare.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passport No.</label>
                                <input
                                    id="passport_no+'index'"
                                    v-model="form.passenger_info[index].passport_no"
                                    name="passport_no+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passport number"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div v-if="is_ticket" class="form-group">
                                <label>Ticket No.</label>
                                <input
                                    id="ticket_no'index'"
                                    v-model="form.passenger_info[index].ticket_no"
                                    name="ticket_no+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Ticket Number"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
<!--                        <div v-if="form.booking_status==='ticket-confirmed'" class="col-md-12">-->
<!--                            <div class="form-group">-->
<!--                                <label>Ticket No.</label>-->
<!--                                <input-->
<!--                                    id="ticket_no+'index'"-->
<!--                                    v-model="form.tickets[index].ticket_no"-->
<!--                                    name="ticket_no+'index'"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="ticket number"-->
<!--                                />-->
<!--                                &lt;!&ndash;                                <div&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    class="invalid-feedback"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                >&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>&ndash;&gt;-->
<!--                                &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
              <button class="btn btn-primary" type="submit">Update</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
